export const platformMyDayHostCapability = 'platform.my-day-host.v1';
export const platformMyDayHostSlots = {
    primary: 'platform.my-day.primary',
};
//# sourceMappingURL=platform-my-day-host.contract.js.map